// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./sound-matrix.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./head.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.o2wiGlP1rjer0fUmm9od{width:100%;height:100%;display:flex;flex-direction:row;gap:4em;justify-content:center;align-items:center}.o2wiGlP1rjer0fUmm9od .UUH0yBDe8jq5TKSWmBs0{flex:0 1 50%;min-height:300px;aspect-ratio:548/465;background-image:url(${___CSS_LOADER_URL_REPLACEMENT_0___});background-repeat:no-repeat;background-size:contain}.o2wiGlP1rjer0fUmm9od .UUH0yBDe8jq5TKSWmBs0 .lkK93i616LAqBSUlnI7B{margin-left:20%;margin-top:14%;width:67%;height:62%;display:grid;grid-template-columns:repeat(5, 1fr);grid-template-rows:repeat(3, 1fr);justify-content:center;align-items:center}.o2wiGlP1rjer0fUmm9od .UUH0yBDe8jq5TKSWmBs0 .lkK93i616LAqBSUlnI7B .fDXx5mvBhRZb5Ikef03n{width:100%;height:100%;cursor:pointer}.o2wiGlP1rjer0fUmm9od .UUH0yBDe8jq5TKSWmBs0 .lkK93i616LAqBSUlnI7B .vqMnA04Jj3hyYXs2i8m2{background-image:url(${___CSS_LOADER_URL_REPLACEMENT_1___});background-repeat:no-repeat;background-size:contain;background-position:center}.o2wiGlP1rjer0fUmm9od .TKyIRRSiJb4LP5UVEB0U{flex:0 1 250px}.o2wiGlP1rjer0fUmm9od .TKyIRRSiJb4LP5UVEB0U .PD3dtRorkB0tOFiGZZdy{display:flex;flex-direction:column;gap:2em}.o2wiGlP1rjer0fUmm9od .TKyIRRSiJb4LP5UVEB0U .PD3dtRorkB0tOFiGZZdy .XkEv2QP50ZQZItXiAszH{display:flex;flex:0 0 100%;flex-direction:row;gap:1em;align-items:center}.o2wiGlP1rjer0fUmm9od .TKyIRRSiJb4LP5UVEB0U .PD3dtRorkB0tOFiGZZdy .XkEv2QP50ZQZItXiAszH .cicdPBexOCfK9SDrRLyo{flex:1 1 50%;text-transform:uppercase;font-weight:bold}.o2wiGlP1rjer0fUmm9od .TKyIRRSiJb4LP5UVEB0U .PD3dtRorkB0tOFiGZZdy .XkEv2QP50ZQZItXiAszH .d_McUsqOkJS3uuqlshEW{flex:1 1 50%}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"primary-dark": `#e73b05`,
	"primary": `#ff6040`,
	"primary-light": `#ffe4df`,
	"primary-extra-light": `#fff2f0`,
	"secondary-dark": `#8292b1`,
	"secondary": `#99a8c6`,
	"secondary-light": `#d0dae9`,
	"secondary-extra-light": `#eef4fc`,
	"default-dark": `#898ca7`,
	"default": `#b8baca`,
	"default-light": `#ecedf5`,
	"default-extra-light": `#f8f8f8`,
	"warning-dark": `#d96800`,
	"warning": `#fbab00`,
	"warning-light": `#ffeba3`,
	"warning-extra-light": `#fff5d1`,
	"info-dark": `#0a82c6`,
	"info": `#2eb6ea`,
	"info-light": `#beebfc`,
	"info-extra-light": `#dff5fe`,
	"success-dark": `#069941`,
	"success": `#3aaa35`,
	"success-light": `#c6f1c3`,
	"success-extra-light": `#e3f9e1`,
	"danger-dark": `#cd0101`,
	"danger": `#ff4141`,
	"danger-light": `#ffcece`,
	"danger-extra-light": `#ffe7e7`,
	"text-primary": `#131a4f`,
	"text-secondary": `#8292b1`,
	"shadow-25": `rgba(184,186,202,.25)`,
	"shadow-50": `rgba(184,186,202,.5)`,
	"pageWrapper": `o2wiGlP1rjer0fUmm9od`,
	"soundMapWrapper": `UUH0yBDe8jq5TKSWmBs0`,
	"soundMap": `lkK93i616LAqBSUlnI7B`,
	"soundMapItem": `fDXx5mvBhRZb5Ikef03n`,
	"active": `vqMnA04Jj3hyYXs2i8m2`,
	"dataWrapper": `TKyIRRSiJb4LP5UVEB0U`,
	"dataTable": `PD3dtRorkB0tOFiGZZdy`,
	"dataTableRow": `XkEv2QP50ZQZItXiAszH`,
	"dataTableLabelCol": `cicdPBexOCfK9SDrRLyo`,
	"dataTableValueCol": `d_McUsqOkJS3uuqlshEW`
};
export default ___CSS_LOADER_EXPORT___;
